import React from "react";
import middleware from "./middlewares/middleware";
import AllCampaignBannerSimpleManage from "../component/sections/campaigns/manage/banner/simple/AllCampaign";
import AllCampaignNativeSimpleManage from "../component/sections/campaigns/manage/native/simple/AllCampaign";
import AllCampaignPushSimpleManage from "../component/sections/campaigns/manage/push/simple/AllCampaign";
import ManageViewCampaign from "../component/sections/campaigns/manage/banner/simple/ViewCampaign";
import ManageEditNativeCampaign from "../component/sections/campaigns/manage/native/simple/EditCampaign";
import InfoDeletedBannerCampaign from "../component/sections/campaigns/manage/banner/simple/InfoDeletedCampaign";
import InfoDeletedNativeCampaign from "../component/sections/campaigns/manage/native/simple/InfoDeletedCampaign";
import AddCampaignAlternative from "../component/sections/campaigns/manage/banner/alternative/AddCampaign";
import AllCampaignAlternative from "../component/sections/campaigns/manage/banner/alternative/AllCampaign";
import InfoCampaignAlternative from "../component/sections/campaigns/manage/banner/alternative/InfoCampaign";
import LogsAmountCampaign from "../component/sections/campaigns/manage/banner/alternative/LogsAmountCampaign";

const manageCampaignsRoutes = [
  {
    path: "/campaigns/manage/banner/simple/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaignBannerSimpleManage />,
        "AllCampaignBannerSimpleManage"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/native/simple/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaignNativeSimpleManage />,
        "AllCampaignNativeSimpleManage"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/push/simple/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaignPushSimpleManage />,
        "AllCampaignPushSimpleManage"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/banner/simple/view/:id/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageViewCampaign />,
        "ManageViewCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/native/simple/edit/:id/:userID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageEditNativeCampaign />,
        "ManageEditNativeCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/banner/simple/info-deleted/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoDeletedBannerCampaign />,
        "InfoDeletedBannerCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/native/simple/info-deleted/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoDeletedNativeCampaign />,
        "InfoDeletedNativeCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/banner-alternative/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCampaignAlternative />,
        "AllCampaignAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/banner-alternative/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCampaignAlternative />,
        "AddCampaignAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/banner-alternative/info/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoCampaignAlternative />,
        "InfoCampaignAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/campaigns/manage/banner-alternative/logs-amount/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <LogsAmountCampaign />,
        "LogsAmountCampaign"
      );
    },
    exact: true,
  },
];

export default manageCampaignsRoutes;
